// extracted by mini-css-extract-plugin
export default {"errorBanner":"errorBanner---G0rl4"};